var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticStyle:{"width":"300px"},attrs:{"outlined":"","dense":"","placeholder":_vm.placeholder,"clearable":"","value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }